export default __webpack_public_path__ + "static/media/download.7ef798e8.svg";